import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import benefitHomeTh1 from "../../image/benefitHomeTh1.jpg";
import benefitHomeTh2 from "../../image/benefitHomeTh2.jpg";
import benefitHomeTh3 from "../../image/benefitHomeTh3.jpg";
import benefitHomeTh4 from "../../image/benefitHomeTh4.jpg";
import hexagonth1 from "../../image/hexagonth1.png";
import hexagonth2 from "../../image/hexagonth2.png";
import hexagonth3 from "../../image/hexagonth3.png";
import { AppContext } from '../../AppContext';

const HomePage = () => {
  const navigate = useNavigate();
  const { setCurrentStep, responseMessage } = useContext(AppContext);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1180) {
        document.querySelector('.fixedblk').classList.add('fixedNow');
      } else {
        document.querySelector('.fixedblk').classList.remove('fixedNow');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleClick = () => {
    setCurrentStep(1);
    navigate("/checkList");
  };

  const handleClickAppStatus = () => {
    setCurrentStep(2);
    navigate("/checkApplicationStatus");
  };

  return (
    <div>
      <div className="bg-image d-flex justify-content-center align-items-center bannerHome">
        <div className='container-fluid'>
          <h1>{responseMessage?.name} has partnered with Cellhub, <span className='inlineblk'>T-Mobile's</span> Platinum Primary Agent, to enable you to
            unlock untapped mobility revenue potential through industry-leading 5G solutions.
          </h1>
          <a onClick={handleClick} className="btn btn-sm btn-primary primaryBtn">
            BECOME A DEALER
          </a>&nbsp;
          <a onClick={handleClickAppStatus} className="btn btn-sm btn-secondary secondaryBtn">
            CHECK APPLICATION STATUS
          </a>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center">
              <h5 className="h5title marT0"><span>About Us</span></h5>
              <h3>Who is Cellhub?</h3>
              <p className="pHeading">
                With over 25 years as T-Mobile's exclusive Primary Agent, Cellhub stands as the
                premier wireless solutions expert, delivering unmatched industry knowledge and
                partner support. Our dedicated focus on T-Mobile's industry-leading 5G network
                enables partners to quickly scale their mobility business while maximizing recurring
                revenue through premium commissions, superior sales support, and cutting-edge tools.
              </p>
            </div>
          </div>

          <br className="hiddenTab" />
          <div className="row">
            <div className="col-sm-12 text-center">
              <h5 className="h5title"><span>3 Step Process</span></h5>
              <h3>Ready to sell T-Mobile?</h3>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <div className="homeReadySellBg">
                <span><img src={hexagonth1} alt="0" /></span>
                <h6>STEP 1</h6>
                <p className="top98">Click on the <br className="hiddenTab" />"BECOME A DEALER" button <br className="hiddenTab" />below to get started.</p>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="homeReadySellBg">
                <span><img src={hexagonth2} alt="2" /></span>
                <h6>STEP 2</h6>
                <p>Once approved by <br className="hiddenTab" />T-Mobile, Cellhub will <br className="hiddenTab" />send you your <br className="hiddenTab" />onboarding documents <br className="hiddenTab" />via DocuSign.</p>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="homeReadySellBg">
                <span><img src={hexagonth3} alt="3" /></span>
                <h6>STEP 3</h6>
                <p>After onboarding, <br className="hiddenTab" />you're ready to sell <br className="hiddenTab" />T-Mobile products and <br className="hiddenTab" />services as an <br className="hiddenTab" />official Sub-Dealer.</p>
              </div>
            </div>
          </div>
        </div>

        <br className="hiddenTab" />

        <div className="benefitHome">
          <div className="container">
            <h5 className="h5title text-center"><span>Why Partner with Cellhub?</span></h5>            
            <h3 className='text-center'>Benefits of becoming a Cellhub Sub-Dealer</h3>
            <div className="row">
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-3">
                    <div className="benefitBox">
                      <p className="benefit1">
                        Best-in class API-enabled Portal for Activating, Managing lines and
                        Commissions all-in one place.
                      </p>
                      <img src={benefitHomeTh1} alt="benefit1" />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="benefitBox">
                      <p className="benefit2">
                        New and lucrative Revenue stream created for your business.
                      </p>
                      <img src={benefitHomeTh2} alt="benefit2" />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="benefitBox">
                      <p className="benefit3">
                        Exposure of your business products/services to over 3,000 Nationwide
                        T-Mobile for Business Sales Reps.
                      </p>
                      <img src={benefitHomeTh3} alt="benefit3" />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="benefitBox">
                      <p className="benefit4">
                        Enables your business to incorporate 5G into solution sets.
                      </p>
                      <img src={benefitHomeTh4} alt="benefit4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </section>
      <div className="fixedblk">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <a onClick={handleClick} className="btn btn-sm btn-primary primaryBtn">
                  BECOME A DEALER
                </a>
                &nbsp;
                <a onClick={handleClickAppStatus} className="btn btn-sm btn-secondary secondaryBtn">
                  CHECK APPLICATION STATUS
                </a>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default HomePage;
